/**
 * @desc 订单发起退款
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: defs.walmart.WalmartOrderRefundRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrderReturns/orderRefund`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
